import { ReactNode } from 'react';

import { NoResultsMessage } from '../SharedStyledComponents';
import { RenderNoItemsFoundFunction } from '../types';

type NoItemsFoundProps<Item> = {
  customRenderNoItemsFound?: RenderNoItemsFoundFunction<Item>;
  searchInputValue: string;
  items: Item[];
};

/**
 * Component that displays a message when no items are found in the autocomplete dropdown.
 * Can be customized by providing a custom renderNoItemsFound function in props.
 */
export const NoItemsFound = <Item,>({
  customRenderNoItemsFound,
  searchInputValue,
  items,
}: NoItemsFoundProps<Item>): ReactNode => {
  if (customRenderNoItemsFound) {
    return customRenderNoItemsFound({ searchInputValue, items });
  }

  return (
    <NoResultsMessage data-testid="no-items-found">
      No results found.
    </NoResultsMessage>
  );
};
